import { render, staticRenderFns } from "./EditEnrolment.vue?vue&type=template&id=534b4fba&scoped=true&"
import script from "./EditEnrolment.vue?vue&type=script&lang=js&"
export * from "./EditEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b4fba",
  null
  
)

export default component.exports